import axios from "axios";
import authHeader from "./auth-header";

const url = process.env.VUE_APP_API_URL;
const imagemBaseUrlRaw =
  process.env.VUE_APP_IMAGEM_BASE_URL ||
  "https://api.grupoparque.com.br/recordacao/";
const imagemBaseUrl = imagemBaseUrlRaw.endsWith("/")
  ? imagemBaseUrlRaw
  : `${imagemBaseUrlRaw}/`;

/** URL completa do arquivo (base IMAGEM + nome_arquivo_foto_perfil). */
export function getFotoPerfilUrl(nomeArquivo) {
  if (!nomeArquivo || nomeArquivo.startsWith("data:")) return null;
  return imagemBaseUrl + nomeArquivo;
}

export const http = axios.create({
  baseURL: url,
});

/**
 * Busca bytes da imagem via API (evita CORS no canvas / html-to-image).
 * Backend: GET /cliente/imagem-santinho?fileName=<nome do arquivo>
 */
export async function fetchImagemSantinhoBlobUrl(fileName) {
  if (!fileName) return null;
  const qs = new URLSearchParams({ fileName: String(fileName) }).toString();
  const res = await http.get(`cliente/imagem-santinho?${qs}`, {
    responseType: "blob",
    headers: { ...authHeader() },
  });
  const blob = res.data;
  if (!(blob instanceof Blob) || blob.size === 0) return null;
  if (blob.type?.includes("json")) return null;
  return URL.createObjectURL(blob);
}

http.defaults.timeout = 300000;

http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default {
  url
}